const STATUS_COLOR_MAP: Record<string, string> = {
  '2': 'success',
  '3': 'processing',
  '4': 'warning',
  '5': 'error',
} as const;

/**
 * HTTP 상태 코드를 Ant Design Tag 색상으로 변환
 * @param status - HTTP 상태 코드 또는 에러 문자열
 * @returns Ant Design Tag 색상 ('success', 'processing', 'warning', 'error', 'default')
 */
export const getStatusColor = (status: number | string): string => {
  const statusStr = String(status);

  if (statusStr === 'error') return 'error';

  const firstChar = statusStr[0];
  return STATUS_COLOR_MAP[firstChar] || 'default';
};
